function key() {
  // Generate a random integer that is less then Number.MAX_SAFE_INTEGER
  return String(Math.trunc(Math.random() * 1000000000000000));
}

export default {
  key,
};
